"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.translate = exports.allLocalTranslations = exports.getIntlMessage = exports.replaceKeysWithValues = exports.Locale = exports.defaultLanguage = exports.TranslationsProvider = void 0;
__exportStar(require("./translationsLibraryImports"), exports);
var i18nProvider_1 = require("./i18nProvider");
Object.defineProperty(exports, "TranslationsProvider", { enumerable: true, get: function () { return __importDefault(i18nProvider_1).default; } });
Object.defineProperty(exports, "defaultLanguage", { enumerable: true, get: function () { return i18nProvider_1.defaultLanguage; } });
Object.defineProperty(exports, "Locale", { enumerable: true, get: function () { return i18nProvider_1.Locale; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "replaceKeysWithValues", { enumerable: true, get: function () { return utils_1.replaceKeysWithValues; } });
Object.defineProperty(exports, "getIntlMessage", { enumerable: true, get: function () { return utils_1.getIntlMessage; } });
var locales_1 = require("./locales");
Object.defineProperty(exports, "allLocalTranslations", { enumerable: true, get: function () { return __importDefault(locales_1).default; } });
var translate_1 = require("./translate");
Object.defineProperty(exports, "translate", { enumerable: true, get: function () { return __importDefault(translate_1).default; } });
var useTranslation_1 = require("./useTranslation");
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return __importDefault(useTranslation_1).default; } });
